<template>
    <div class="DeleteAccountPanel">
        <ActionPanel class="delete-panel" title="Usuń konto">
            <template v-slot:actions>
                <SmallButton
                    border-color="danger"
                    icon="trash"
                    @click="confirmDeletePopup = true"
                    >
                    Usuń
                </SmallButton>
            </template>
        </ActionPanel>
        <ConfirmDeleteAccountPopup
            :enabled="confirmDeletePopup"
            :accountEmail="account.email"
            @close="confirmDeletePopup = false"
            @confirm="$emit('delete')"
            />
    </div>
</template>

<script>
    import ActionPanel from '@/components/accountView/ActionPanel.vue';
    import ConfirmDeleteAccountPopup from '@/components/accountView/ConfirmDeleteAccountPopup.vue';
    import SmallButton from '@/components/input/SmallButton.vue';

    export default {
        name: 'DeleteAccountPanel',
        components: {
            ActionPanel,
            ConfirmDeleteAccountPopup,
            SmallButton,
        },
        props: {
            account: {
                required: true,
            },
        },
        data() {
            return {
                confirmDeletePopup: false,
            };
        },
        methods: {
            toggleEditing() {
                this.editable = !this.editable;
            },
            saveChanges(invalid) {
                if (!invalid) {
                    this.$emit('save', {
                        currentPassword: this.currentPassword,
                        newPassword: this.newPassword,
                    });
                    this.editable = false;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/globals.scss";

    .fields {
        margin-top: 10px;
        opacity: 0;
        pointer-events: none;

        transition: 0.1s ease-out opacity;

        &.editable {
            pointer-events: unset;
            opacity: 1;
        }
    }
</style>
